import { useState } from 'react';
import { getHubUrl, setHubUrl, setToken } from '../config';

interface Props {
  onDone: () => void;
}

export function Setup({ onDone }: Props) {
  const [url, setUrl] = useState(getHubUrl());
  const [token, setTokenInput] = useState('');
  const [err, setErr] = useState<string | null>(null);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!token.trim()) {
      setErr('Token required');
      return;
    }
    setHubUrl(url.trim());
    setToken(token.trim());
    onDone();
  };

  return (
    <main className="setup">
      <div className="setup-card">
        <h1 className="setup-title">Pocket</h1>
        <p className="setup-sub">One-time setup. Paste your hub URL and token.</p>
        <form onSubmit={submit}>
          <label className="field">
            <span>Hub URL</span>
            <input
              type="url"
              value={url}
              placeholder="https://pocket-hub.workers.dev"
              onChange={(e) => setUrl(e.target.value)}
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
            />
          </label>
          <label className="field">
            <span>Bearer token</span>
            <input
              type="password"
              value={token}
              placeholder="POCKET_TOKEN"
              onChange={(e) => setTokenInput(e.target.value)}
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
            />
          </label>
          {err && <div className="setup-err">{err}</div>}
          <button type="submit" className="btn btn-primary">
            Continue
          </button>
        </form>
      </div>
    </main>
  );
}
